//import React from 'react';
import React, { useEffect, useRef } from "react";
import * as actions from './Actions';

export default function ({ sideBarData, eleRef }) {
  // //console.log("eleref childoverlay",eleRef);
  var childProfileData = eleRef.state.childProfileData.childArr;
  // //console.log("childProfileData overlay========",childProfileData);
  var selectedchild=eleRef.state.selectedChild
  // //console.log("global===========",global)
  
  const popupRef = useRef(null);
  
    useEffect(() => {
      const handleKeyDown = (e) => {
        const popupOverlay = document.querySelector(
          ".select_child_popup.addAns-overlay"
        );
        if (!popupOverlay) return;
  
        const isVisible = window.getComputedStyle(popupOverlay).display !== "none";
        if (!isVisible) return; // only work when popup is open
  
        const popup = popupRef.current;
        if (!popup) return;
  
        // ESC closes popup
        if (e.key === "Escape" || e.key === "Esc") {
          console.log("Escape key pressed from profile");
          e.preventDefault();
          
          const prevFocusable = document.querySelector('[data-popup="select profile"]');
          if (prevFocusable) prevFocusable.focus();
          actions.closePopupcommon2();
          return;
        }
  
        // TAB: keep focus inside popup
        if (e.key === "Tab") {
          const focusableSelectors = `
            a[href], area[href], input:not([disabled]),
            select:not([disabled]), textarea:not([disabled]),
            button:not([disabled]), [tabindex]:not([tabindex="-1"])
          `;
  
          const focusableElements = Array.from(
            popup.querySelectorAll(focusableSelectors)
          ).filter((el) => el.offsetParent !== null); // visible elements only
  
          if (focusableElements.length === 0) return;
  
          const firstEl = focusableElements[0];
          const lastEl = focusableElements[focusableElements.length - 1];
          const activeEl = document.activeElement;
  
          // If Shift+Tab from first element → go to last
          if (e.shiftKey) {
            if (activeEl === firstEl || !popup.contains(activeEl)) {
              e.preventDefault();
              lastEl.focus();
            }
          } else {
            // Tab from last element → go to first
            if (activeEl === lastEl || !popup.contains(activeEl)) {
              e.preventDefault();
              firstEl.focus();
            }
          }
        }
      };
  
      // Attach global listener
      document.addEventListener("keydown", handleKeyDown);
  
      return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);
  
    // // Ensure popup gets focus when opened
    // useEffect(() => {
    //   const popupOverlay = document.querySelector(
    //     ".select_child_popup.addAns-overlay"
    //   );
    //   if (!popupOverlay) return;
  
    //   const observer = new MutationObserver(() => {
    //     const isVisible = window.getComputedStyle(popupOverlay).display !== "none";
    //     if (isVisible && popupRef.current) {
    //       // Focus first visible focusable element
    //       const focusable = popupRef.current.querySelector(
    //         `textarea, input, [tabindex]:not([tabindex="-1"])`
    //       );
    //       if (focusable) focusable.focus();
    //     }
    //   });
  
    //   observer.observe(popupOverlay, { attributes: true, attributeFilter: ["style"] });
    //   return () => observer.disconnect();
    // }, []);
    
    return (
<div className="select_child_popup addAns-overlay">
                           <div className="addAns-popup select_child_popup select_child_popup_feeds" role="dialog" ref={popupRef} aria-modal="true">
                              <div className="all_select_child_popups" style={{ display: "block" }}>
                                 <div className="select_child_heading_view"> 
                                    <div className="close_popup_feeds_all" onClick={()=>{actions.closePopupcommon2()}} role='button' tabIndex={0} aria-label='Close Select Child Popup' onKeyDown={(e)=>{if(e.key==='Enter'){
                                      const prevFocusable = document.querySelector('[data-popup="select profile"]');
                                      if (prevFocusable) prevFocusable.focus();
                                      actions.closePopupcommon2();
                                    }}}> 
                                      <span data-icon-font="C" className="icon"></span>
                                    </div>
                                    <div className="child_headeing_text M17_21" role='heading' tabIndex={0} aria-label='Select Child'> Select Child</div>
                                    <div className="child_my_profile M12_pink"> 
                                      <a className="M12_pink gtm-baby-swipe" href="https://parenting.firstcry.com/my-account/myprofile" tabIndex={0} aria-label='Go to My Profile'> <span className="gtm-baby-swipe icon left" data-icon-font="?">  </span> My Profile </a> 
                                    </div>
                                 </div>
                                 <div className="child_details_cirecl">
                                   <ul className="baby_child_login_circle_div">
                                    {childProfileData && childProfileData.length > 0 && childProfileData.map((profile,index)=>
                                    <li key={index} className={eleRef.state.selectedChild.childId == profile.childId ? "baby_child1 active":"baby_child1"} onClick={()=>eleRef.getLatestFeedByChild(profile)}   id={"ChilProf_"+profile.childId} data-profile={profile.isExpecting!=1 && profile.childId!=""? profile.childName : profile.isExpecting!=1 && profile.isTryingToConceive > 0 ? "Trying to Concieve" : "Expecting"} role='button' tabIndex={0} aria-label={'Select '+ (profile.isExpecting!=1 && profile.childId!=""? profile.childName : profile.isExpecting!=1 && profile.isTryingToConceive > 0 ? "Trying to Conceive" : "Expecting") +' profile'} onKeyDown={(e)=>{if(e.key==='Enter'){eleRef.getLatestFeedByChild(profile)}}}>
                                     
                                       <div className="name_profile">
                                    <div className="chld_prof">
                                      
                                        {profile.isExpecting!=1 && profile.isTryingToConceive >0 && profile.childName==""?

                                        <div>
                                          <img className="no_babyImg dev_chld_prof" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/07-Trying-to-concieve.webp" title={profile.childName} alt={profile.childName} />
                                          </div>
                                        
                                        :
                                        profile.isExpecting!=1  && profile.childPhoto == "" ?
                                            <div>
                                              {profile?.age?.year == 0?
                                                   (<img className="no_babyImg dev_chld_prof" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/01-Infant.webp" title={profile.childName} alt={profile.childName} />):

                                            
                                                    profile?.age?.year < 2 ?
                                                        (<img className="no_babyImg dev_chld_prof" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/02-Baby.webp" title={profile.childName} alt={profile.childName} />):
                                                        profile?.age?.year < 4 ?
                                                        (<img className="no_babyImg dev_chld_prof" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/03-Toddler.webp" title={profile.childName} alt={profile.childName} />
                                                        ):
                                                        (<img className="no_babyImg dev_chld_prof" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/05-Big Kids.webp" title={profile.childName} alt={profile.childName} />)}
                                                         </div>
                                        
                                         :profile.isExpecting==1 ? 
                                             (<img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp" title="Expecting Baby" className="dev_chld_prof" alt="Expecting Baby" />
                                             ):
                                         profile.isExpecting==1 && profile.userPic ?  
                                            (<img src={(profile.userPic)} title="Expecting Baby" className="dev_chld_prof" alt="Expecting Baby" />
                                            ):
                                            
                                         (<img src={profile.childPhoto ? profile.childPhoto.replace("http://","https://"):''}className="dev_chld_prof" title={profile.childName} alt={profile.childName} /> )}
                                        
                                    </div>
                                    {profile.isExpecting!=1 && profile.childId!=""? 
                                    <div>
                                        <div className="chld_name">
                                            <span className="chld_name_span M15_42">
                                                {profile.childName}
                                            </span>
                                        </div>
                                        </div>
                                        :
                                        <div>
                                              {profile.isExpecting!=1 && profile.isTryingToConceive > 0 ? 
                                              <div className="chld_name">
                                                  <span className="chld_name_span M15_42">Trying to Concieve</span>
                                              </div>:
                                              <div className="chld_name">
                                                  <span className="chld_name_span M15_42">Expecting</span>
                                              </div>
                                              }
                                </div>}
                                </div>
                                    </li>
                                   
                                   ) }
                                 </ul>
                                 </div>
                              </div>
                             
                            </div>
                        </div>
                        )
  }
